import { Card, CardContent, CardHeader } from "@mui/material";
import { Component } from "react";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import Environment from "../../utils/Environement";
import { shortenUUID } from "../../utils/formater";

interface PropsInterface {
  restaurant: PopinaRestaurant;
}

class MenusTableComponent extends Component<PropsInterface> {
 
  getMenuPrice = (menu: any) => {
    if (!menu?.prices?.length) return 0;
    const price = menu.prices.find((p: any) => p.price_type === 0);
    const amount = price ? price.amount : menu.prices[0].amount;
    return amount || 0;
  };

  getItemName = (itemId: string) => {
    const item = this.props.restaurant.items.find(
      item => item.client_id === itemId
    );
    return item?.name || "";
  };

  render() {
    return (
      <div style={{ width: "80%", margin: "auto", padding: "20px 0" }}>
        {this.props.restaurant.menus.map((menu: any) => {
          return (
            <Card
              style={{
                margin: "10px 0",
                backgroundColor: "#F1F1F5"
              }}
              key={menu.client_id}
            >
              <CardHeader
                title={menu.name}
                disableTypography
                style={{
                  backgroundColor: "#474F5E",
                  color: "white",
                  fontSize: "20px"
                }}
              />
              <CardContent>
                <div style={{ display: "flex", padding: "10px 0" }}>
                  <p
                    style={{ color: "#474F5E", margin: 0, marginRight: "4px" }}
                  >
                    Identifiant:
                  </p>
                  <p
                    style={{
                      color: "#33499ac2",
                      margin: 0,
                      fontWeight: "bold"
                    }}
                  >
                    {shortenUUID(menu.client_id)}
                  </p>
                </div>
                <div style={{ display: "flex", padding: "10px 0" }}>
                  <p
                    style={{ color: "#474F5E", margin: 0, marginRight: "4px" }}
                  >
                    Prix:
                  </p>
                  <p
                    style={{
                      color: "#33499ac2",
                      margin: 0,
                      fontWeight: "bold"
                    }}
                  >
                    {this.getMenuPrice(menu)} EUR
                  </p>
                </div>
                {menu.steps.map((step: any, i: number) => (
                  <Card
                    style={{
                      margin: "15px 0",
                      marginLeft: "15px",
                      width: "94%",
                      backgroundColor: "#F1F1F5",
                      maxWidth: "800px"
                    }}
                    key={step.client_id}
                  >
                    <CardHeader
                      title={step.name}
                      disableTypography
                      style={{
                        backgroundColor: "#445074",
                        color: "white",
                        fontSize: "16px",
                        padding: "12px 20px"
                      }}
                    />
                    <CardContent>
                      {step.positions.map((p: any) => (
                        <div
                          key={p.client_id}
                          style={{
                            border: Environment.isPopina
                              ? "1px solid #7ABF92"
                              : "1px solid #ffd400",
                            borderRadius: "3px",
                            backgroundColor: "white",
                            display: "flex",
                            margin: "5px",
                            padding: "12px 20px"
                          }}
                        >
                          <p style={{ padding: 0, margin: "0" }}>
                            {this.getItemName(p.client_id)}
                          </p>
                          <p
                            style={{
                              padding: 0,
                              margin: "0",
                              color: "#33499ac2",
                              fontWeight: 600,
                              marginLeft:"2px"
                            }}
                          >
                            ({shortenUUID(p.client_id)})
                          </p>
                        </div>
                      ))}
                    </CardContent>
                  </Card>
                ))}

                {/* <div>
                  <OptionDetailComponent
                    ref={this.modalElement}
                    restaurant={this.props.restaurant}
                  />
                </div> */}
              </CardContent>
            </Card>
          );
        })}
      </div>
    );
  }
}

export default MenusTableComponent;
